import { APITypes } from "@cur8/api-client";
import { Patient, VisitSummary } from "@cur8/rich-entity";
import { createStoreContext, useEntity } from "@pomle/react-flat-store";
import { OnboardingData } from "lib/api/onboarding/type";

function useEntities() {
  return {
    patient: useEntity<Patient>(),
    metrics: useEntity(),
    visits: useEntity<VisitSummary[]>(),
    slots: useEntity<APITypes.Slot[]>(),
    slotCount: useEntity<number>(),
    patientSlots: useEntity<APITypes.Slot[]>(),
    onboarding: useEntity<OnboardingData | undefined>(),
    cart: useEntity<APITypes.Cart>(),
  };
}

const { useStore, StoreContext } = createStoreContext(useEntities);

export { StoreContext, useStore };
